export const apiKey = 'b4120025-3b95-4b55-8625-871876de8700'
export const apiScopes = ['api://82dac785-23db-499d-9d8a-2f2352ad05a3/rooming.read']
export const apiAuthority = 'https://login.microsoftonline.com/29e7a041-29b3-485a-ba7a-808f0fe2c812'
export const apiBasePath = 'https://tokyo2020rooming.ita.sport/'
export const pageSize = 20
